<template>
  <div v-loading="loading">
    <b-field
      :label="label"
      :type="(globalErrorMessage != '' ? 'is-danger': '')"
      :message="`${globalErrorMessage}`"
      class="mb-0"
    >
      <b-upload
        v-model="newFiles"
        drag-drop
        multiple
        :type="(hasError() ? 'is-danger': '')"
        class="media-library-upload"
        @input="onInput"
      >
        <div class="p-3">
          <b-icon icon="upload" />
        </div>
        <div class="pr-3 py-2">
          <p>{{ $t('drop_or_click_to_upload') }}</p>
          <small v-if="max > 1">{{ $t("you_can_upload_up_to_n_files", {number: max}) }}</small>
        </div>
      </b-upload>
    </b-field>
    <div class="media-items">
      <v-media-item
        v-for="(file, index) in existingFiles_"
        :key="file.id"
        :file="file"
        @deleteClick="deleteExistingFile(index)"
      >
        {{ file.file_name }}
      </v-media-item>
      <v-media-item
        v-for="(file, index) in newFiles"
        :key="file.id"
        :file="file"
        :error="errorMessage(name + '.to_add.' + index)"
        @deleteClick="deleteDropFile(index)"
      >
        {{ file.name }}
      </v-media-item>
    </div>
  </div>
</template>

<script>
import InputBase from "./InputBase";
import notificator from "@/services/notificator";
import MediaLibraryItem from "./MediaLibraryItem";

export default {
  components: {
    "v-media-item": MediaLibraryItem
  },
  extends: InputBase,
  props: {
    max: {
      default: 100,
      type: Number
    },
    maxSize: {
      default: 10 * 1024 * 1024,
      type: Number
    },
    mimes: {
      default: null,
      validator: (value) => {
        return _.isArray(value) || value === null;
      }
    },
    existingFiles: {
      default() {
        return [];
      },
      type: Array
    }
  },
  data() {
    return {
      existingFiles_: _.cloneDeep(this.existingFiles),
      newFiles: [],
      toRemove: [],
      loading: false
    };
  },
  computed: {
    numberOfFiles () {
      return this.existingFiles_.length + this.newFiles.length - this.toRemove.length;
    },
    globalErrorMessage () {
      if (this.errorMessage()) {
        return this.errorMessage();
      }
      if (this.errorMessage(this.name + ".to_add")) {
        return this.errorMessage(this.name + ".to_add");
      }
      if (this.errorMessage(this.name + ".to_remove")) {
        return this.errorMessage(this.name + ".to_remove");
      }
      return "";
    }
  },
  created () {
    this.sync();
  },
  methods: {
    onInput(e) {

      let file = this.newFiles[this.newFiles.length - 1];

      if (file == null) {
        return;
      }

      if (this.numberOfFiles >= this.max && this.max > 1) {
        notificator.open({
          message: this.$t("you_can_upload_up_to_n_files", {number: this.max}),
          type: "danger"
        });
        this.removeLastNewFile();
        return;
      }

      if (!this.validateFile(file)) {
        this.removeLastNewFile();
        return;
      }

      this.clearErrors(this.name + ".to_add");
      this.sync();

      if (this.max == 1) {
        if (this.existingFiles_.length > 0) {
          this.deleteExistingFile(0);
        }
        if (this.newFiles.length > 1) {
          this.newFiles.splice(0,this.newFiles.length - 1);
        }
      }
    },
    validateFile(file) {
      if (file == null) {
        notificator.open({
          message: this.$t("no_file_selected"),
          type: "danger"
        });
        return false;
      }

      if (file.size > this.maxSize) {
        notificator.open({
          message: `${this.$t("the_file_size_cannot_exceed")} ${this.maxSize / 1024 / 1024}${"mb"}`,
          type: "danger"
        });
        return false;
      }

      if (_.isArray(this.mimes) && !this.mimes.includes(file.type)) {
        notificator.open({
          message: `${this.$t("the_file_type_is_invalid")} ${this.$t("accepted_types_are")} ${this.mimes.join(", ")}`,
          type: "danger"
        });
        return false;
      }

      return true;
    },
    deleteDropFile(index) {
      // Remove errors on all files
      for (let i = 0; i < this.newFiles.length; i++) {
        this.clearErrors(this.name + ".to_add." + i);
      }
      this.newFiles.splice(index, 1);
      this.sync();
    },
    deleteExistingFile(index) {
      let file = this.existingFiles[index];
      if (file) {
        this.toRemove.push(file.id);
        this.existingFiles_.splice(index, 1);
        this.sync();
      }
    },
    sync () {
      this.inputListener({
        to_remove: this.toRemove,
        to_add: this.newFiles
      });
    },
    removeLastNewFile () {
      this.newFiles.splice(-1,1);
    }
  }
};
</script>

<style lang="scss">

@import "~/scss/variables";

.media-library-upload {
  width: 100%;
  .upload-draggable {
    display: flex;
    align-items: center;
    width: 100%;
    background-color: $white-bis;
    transition: all 200ms;

    &:hover {
      background-color: $white-ter;
    }
  }
}
</style>
